import React from "react";

const Pagination = ({ queries, onPageChange, onPerPageChange }) => {
  const startEntry = (queries.page - 1) * queries.per_page + 1;
  const endEntry = startEntry + queries.per_page - 1;

  return (
    <div className="flex flex-wrap items-center justify-between bg-white px-4 pb-4 rounded-b-md shadow-lg font-ubuntu">
      <div className="flex items-center">
        <span className="mr-2">Show</span>
        <select
          className="border rounded p-1"
          value={queries.per_page}
          onChange={(e) => {
            const newPerPage = parseInt(e.target.value, 10);
            onPerPageChange(newPerPage);
          }}
          aria-label="Items per page"
        >
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
        </select>
        <span className="ml-2">entries</span>
      </div>

      <div className="flex mt-2 sm:mt-0 gap-x-1 py-1 items-center">
        <span className="mr-2">
          Showing {startEntry} to {endEntry} entries
        </span>
        <div className="flex gap-x-1">
          <button
            className="px-3 py-1 border rounded bg-gray-100 text-gray-600"
            disabled={queries.page <= 1}
            onClick={() => onPageChange(queries.page - 1)}
            aria-label="Previous page"
          >
            Previous
          </button>
          <button
            className="px-3 py-1 border rounded bg-gray-100 text-gray-600 hover:text-gray-500"
            onClick={() => onPageChange(queries.page + 1)}
            aria-label="Next page"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
